import { Cover } from 'types/cover';
import { InterestedPartyUI } from 'types/policy';

type InterestedPartiesByCover = {
  [key in Cover]: string[];
};

/**
 * @description
 * Returns a hash map where covers are the key and all
 * of their respective interestedParties are the values
 * in an array
 */
export const getInterestedPartiesByCover = (
  interestedParties: InterestedPartyUI[]
): InterestedPartiesByCover => {
  const interestedPartiesByCover = interestedParties?.reduce(
    (acc, ip) => ({
      ...acc,
      [ip.cover]: [...(ip.cover in acc ? acc[ip.cover] : []), ip.name],
    }),
    {} as InterestedPartiesByCover
  );

  return interestedPartiesByCover;
};
